import bucmAxios from './bucm-axios';

export const getExternalNetworks = () =>
    bucmAxios<BUCM.ExternalNetworksResponseApiResponse>({
        url: '/external-networks',
        method: 'GET'
    });
